import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { BurialStatus } from '../types/types';
import { CommonModule } from '@angular/common';
import { StatusIndicatorComponent } from '../status-indicator/status-indicator.component';
import { IconModule } from '@rogers/cdk/icon';

@Component({
  standalone: true,
  imports: [CommonModule, StatusIndicatorComponent, IconModule],
  selector: 'ucx-burial-status-card',
  templateUrl: './burial-status-card.component.html',
  styleUrls: ['./burial-status-card.component.scss'],
})
export class BurialStatusCardComponent implements AfterViewInit {
  @Input() burialStage: any[] = [];
  @Input() burialClosedText = 'Burial Season Closed';
  @Input() burialTitle = '';
  @Input() burialAddress = '';
  @Input() statusTitle = '';
  @Input() statusList: BurialStatus[] = [];
  @Input() isComplete = [];
  @Input() currentStatusIndex = 0;
  @Input() burialSeasonClosed;
  @ViewChild('currentStatus') currenStatus: ElementRef | undefined;
  currentStage = '';
  initialScrollPosition = 0;
  initialCurrentStatusScrollAreaWidth = 0;
  dynamicCurrentStatusScrollAreaWidth = 0;
  elementReference;

  ngAfterViewInit() {
    this.elementReference = this.currenStatus?.nativeElement;
    this.initialCurrentStatusScrollAreaWidth =
      this.elementReference.scrollWidth;
    this.scrollLeft();
  }

  setCurrentStage = (currentStage): void => {
    this.currentStage = currentStage;
  };

  setStageTitle = (statusTitle): void => {
    this.statusTitle = statusTitle;
  };

  scrollRight() {
    this.elementReference.scrollLeft += 20;
    this.setScrollPosition();
    if (
      this.dynamicCurrentStatusScrollAreaWidth >=
      this.initialCurrentStatusScrollAreaWidth - 41
    ) {
      this.elementReference.scrollLeft += 20;
    }
  }

  scrollLeft() {
    this.elementReference.scrollLeft -= 20;
    this.setScrollPosition();
    if (this.initialScrollPosition < 1) {
      this.initialScrollPosition = this.elementReference.scrollLeft - 20;
    }
  }

  setScrollPosition() {
    this.initialScrollPosition = this.elementReference.scrollLeft;
    this.dynamicCurrentStatusScrollAreaWidth =
      (this.elementReference.scrollLeft || 20) +
      this.elementReference.clientWidth;
  }

  isLast(index: number) {
    if (index === this.statusList.length - 1) return true;
    if (
      this.statusList[index].statusState !==
        this.statusList[index + 1].statusState &&
      index + 1 < this.statusList.length
    ) {
      return true;
    }
    return false;
  }

  isFirst(index: number) {
    if (index === 0) return true;
    if (
      this.statusList[index].statusState !==
        this.statusList[index - 1].statusState &&
      index - 1 > 0
    ) {
      return true;
    }
    return false;
  }

  getPreviousState(index: number) {
    if (index === 0) return '';
    return this.statusList[index - 1];
  }

  applyShadowClass() {
    if (
      this.initialScrollPosition > 0 &&
      this.dynamicCurrentStatusScrollAreaWidth <
        this.initialCurrentStatusScrollAreaWidth - 1
    ) {
      return true;
    }
    return false;
  }
}
